// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";

export const XngExpandApiParameter: typeof PopulateApiParameter = (props: any) => {
    const pageType = getCurrentPage(props.getState()).type;
    const { pathname } = getLocation(props.getState());
    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        expand: [],
    };
    props.apiParameter.expand = ["shipping", "cartLines", "restrictions", "properties", "validation", "tax"];
    const timestamp = `time${new Date().getTime()}`;
    props.apiParameter.expand?.push(timestamp);
    if (props.needFullCart) {
        props.apiParameter.expand = [...(props.apiParameter.expand || []), "carriers", "paymentOptions", "costCodes"];
    } else if (
        props.parameter.fullExpand ||
        pageType === "CheckoutReviewAndSubmitPage" ||
        pageType === "CheckoutShippingPage" ||
        pageType === "OrderConfirmationPage" ||
        pageType === "CartPage" ||
        pageType === "OnePageCheckoutPage"
    ) {
        // https://xngage.atlassian.net/browse/BG-2304
        if (!(pageType === "CartPage" && !props.parameter.showTaxAndShipping)) {
            props.apiParameter.expand?.push("tax");
        }
        if (
            pageType === "CheckoutReviewAndSubmitPage" ||
            pageType === "CheckoutShippingPage" ||
            pageType === "OnePageCheckoutPage"
        ) {
            props.apiParameter.forceRecalculation = true;
            props.apiParameter.allowInvalidAddress = true;
        }
    }

    // https://xngage.atlassian.net/browse/BG-2107
    // Fix price cashing issue on the Cart Page when switching between Delivery and Pickup
    if (pageType === "CartPage") {
        props.apiParameter.forceRecalculation = true;
    }

    if (pageType === "RfqRequestQuotePage" || (pageType === nullPage.type && pathname === "/Rfq")) {
        (props.apiParameter as any).IsRequestQuotePage = true;
    }
};

replaceInChain(chain, PopulateApiParameter, XngExpandApiParameter);
